import {AfterViewInit, Directive, Injector, Input, Optional, ViewChild} from '@angular/core';

import { APPLY_STYLES_TYPE, DISPLAY_TYPE, IWidgetConfig, register, StylableComponent, provideAsWidgetRef, Parent, styler } from "@wm/components-base";
import { runtimeEventManager, switchClass } from '@wm/core';

const DEFAULT_CLS = 'form-group app-composite-widget clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-composite',
  hostClass: DEFAULT_CLS
};

const CAPTION_POSITION: {[key: string]: string} = {
  left: 'caption-left',
  right: 'caption-right',
  top: 'caption-top',
  floating: 'caption-floating'
};

@Directive({
  selector: 'div[wmComposite]',
  providers: [
  provideAsWidgetRef(CompositeDirective)
  ],
  standalone: true,
  exportAs: 'wmComposite'
})
export class CompositeDirective extends StylableComponent implements AfterViewInit {
  static initializeProps = register('wm-composite');
  private placeholder?: string;

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
  }

  override ngAfterViewInit() {
    this.placeholder = $(this.nativeElement).find('input, select, textarea').attr('placeholder');
    super.ngAfterViewInit();
  }

  override onPropertyChange(key: string, nv: any, ov: any) {
    let labelEle: any, inputElements: any;
    switch (key) {
      case 'required':
        setTimeout(()=>{
          labelEle = $(this.nativeElement).find('.app-label');
          inputElements = ['.input-group', '.form-control', 'app-radio', '.list-group', '.app-checkbox'];
          if (labelEle.length) {
            labelEle[0].widget.required = nv;
          }
          inputElements.forEach((ele: string)=>{
            let inputEle: any = $(this.nativeElement).find(ele);
            if (inputEle.length) {
              let inputComponent: any = inputEle[0].closest('[widgetid]').widget;
              inputComponent.required = nv;
            }
          })
        },0)
        break;
      case 'captionposition':
        switchClass(this.nativeElement, CAPTION_POSITION[nv], CAPTION_POSITION[ov]);
        if (this.placeholder)
          $(this.nativeElement).find('input, select, textarea').attr('placeholder', this.placeholder);
        if (nv === 'floating') {
          runtimeEventManager.emit('apply-floating-caption')
        }
        break;
      default:
        super.onPropertyChange(key, nv, ov);
    }
  }
}

